var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavVAccesos = function SvgNavVAccesos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_v_accesos_svg__Capa_2",
    viewBox: "0 0 34.06 34.06"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_v_accesos_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.33 16.41 5.55 5.55 9.85-9.85",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px",
    stroke: "#19d3c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.03,
    cy: 17.03,
    r: 16.28,
    stroke: "#b3b3b3",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavVAccesos;